module.exports = {
    alteracaoRse: 'Alteração de processo de RSE',
    alterarAutorizador: 'Alterar autorizador',
    encaminhadoOperador: 'Encaminhado',
    encaminhadoAutorizador: 'Encaminhado',
    alterarDataValidade: 'Alterar data de validade',
    alterarNumeroRse: 'Alterar número da RSE',
    anexosObrigatorios: 'A adição da TCLE, do formulário, do laudo médico, do comprovante de regulação da consulta ambulatorial e da solicitação hospitalar é obrigatória',
    anoMesProcedencia: 'Ano e mês de procedência',
    rseContinuidade: 'RSE continuidade',
    rsePadrao: 'Solicitação padrão',
    comprovarServico: 'Comprovar serviço',
    atencaoAdicaoAnexos: tipoSolicitacao => tipoSolicitacao === 'P' ? 'Anexe aqui o processo: histórico do SGPe, laudo médico, exames obrigatórios, comprovante do SISREG e documentos pessoais (RG, CPF, comprovante de residência). Todos são obrigatórios.' : 'Anexe aqui o processo: laudo médico (obrigatório) e exames complementares (não obrigatório).',
    atencaoAdicaoAnexosGerais: 'Anexe aqui o TCLE, o comprovante de regulação da consulta ambulatorial ou demanda judicial, a solicitação hospitalar do procedimento no SISREG, o laudo médico e os exames complementares. Você também pode adicionar novos documentos clicando no símbolo de "+"',
    deferimento: 'Deferimento',
    deferido: 'Deferido',
    indeferir: 'Indeferir',
    justificativaTamanhoMinimo: 'A justificativa deve conter no mínimo 10 caracteres',
    numeroRequisicao: 'Número da requisição',
    deferidoAdministrador: 'Deferido pelo administrador',
    deferidoOperador: 'Deferido pelo operador',
    deferidoPeloMedicoAutorizador: 'Deferido',
    avisoPossibilidadeTransplante: 'A opção "Transplante" agora está habilitada na seção "Procedência do pedido"',
    cancelado: 'Cancelado',
    cancelamento: 'Cancelamento',
    numeroDemandaJudicial: 'Número da demanda judicial',
    carregandoInstituicoesAutorizadoras: 'Carregando instituições autorizadoras',
    carregandoInstituicoesSolicitantes: 'Carregando instituicões solicitantes',
    cid10Secundario: 'CID-10 Secundário',
    cidadeAutorizadora: 'Cidade autorizadora',
    cidadeSolicitante: 'Cidade solicitante',
    cnsPaciente: 'CNS do paciente',
    codigoProcedimento: 'Código do procedimento',
    comNumero: 'Com número',
    complementoProcedencia: 'Complemento da procedência',
    complexosRegulatorios: 'Complexos regulatórios',
    confirmacaoSolicitarNumeroRse: 'Você deseja solicitar um número para este processo de RSE?',
    confirmarAutorizacao: 'Confirma a autorização deste processo?',
    confirmarSalvarFuncionariosComplexoRegulatorio: 'Você deseja vincular estes autorizadores ao complexo regulatório escolhido?',
    cpfPaciente: 'CPF do paciente',
    dadosProcedimento: 'Dados do procedimento',
    dadosSigtap: 'Dados SIGTAP',
    dataAutorizacao: 'Data da autorização',
    dataFinalAutorizacao: 'Data final da autorização',
    dataFinalValidade: 'Data final de validade',
    dataGeracaoNumeroRse: 'Data de geração do número da RSE',
    dataInicialAutorizacao: 'Data inicial da autorização',
    dataSolicitacaoLaudo: 'Data de solicitação do laudo',
    dataValidade: 'Data de validade',
    descricaoProcedimento: 'Descrição do procedimento',
    desmarcarTodos: 'Desmarcar todos',
    devolucao: 'Devolução',
    devolvendoNumeroRse: 'Devolvendo número da RSE',
    devolverNumeroRse: 'Devolver o número para a lista',
    devolverOperador: 'Operador',
    devolverSolicitante: 'Solicitante',
    devolvido: 'Devolvido',
    emAnalise: 'Em análise',
    encaminharAutorizador: 'Encaminhar ao autorizador',
    erroAlterarSolicitacao: 'Houve um erro ao editar a solicitação da RSE. Tente novamente mais tarde.',
    erroDevolverNumeroRse: 'Ocorreu um erro ao devolver o número da RSE',
    erroImprimirProcesso: 'Ocorre um erro ao imprimir o processo. Tente novamente mais tarde.',
    erroIniciarNovaSolicitacao: 'Não foi possível inicializar a solicitação de RSE. Tente novamente mais tarde.',
    erroInvalidarNumeroRse: 'Ocorreu um erro ao invalidar o número da RSE',
    erroPesquisaProcedimentoSigtap: 'Houve um erro na busca de procedimentos SIGTAP. Tente novamente mais tarde.',
    erroRecuperacaoFuncionarioComplexoRegulatorio: 'Ocorreu um erro ao recuperar os funcionários do complexo regulatório. Por favor, tente mais tarde.',
    erroRecuperacaoMotivoCancelamento: 'Ocorreu um erro ao recuperar os motivos de cancelamento. Por favor, tente mais tarde.',
    erroRecuperacaoMotivoDevolucao: 'Ocorreu um erro ao recuperar os motivos de devolução. Por favor, tente mais tarde.',
    erroSolicitarNumeroRse: 'Ocorreu um erro ao gerar o número para este processo',
    examesComplementares: 'Exames complementares',
    faixaRse: 'Faixa da RSE',
    faixaGeral: 'Geral',
    faixaOci: 'OCI',
    fecharTodosHistoricos: 'Fechar todos os históricos',
    folhaAutorizacao: 'Folha de autorização do sistema de controle AC',
    funcionarioAdministrador: 'Funcionário administrador',
    funcionarioAutorizador: 'Funcionário autorizador',
    funcionarioSolicitante: 'Funcionário solicitante',
    gerandoNumeroRse: 'Gerando número de RSE',
    imprimindoRse: 'Imprimindo processo de RSE',
    informeRseContinuidade: 'Detectamos que já existem processos de mesmo procedimento e unidade executora para este paciente. Você poderá marcar esta solicitação como do tipo continuidade, se desejar',
    informeRseOci: 'Detectamos que a solicitação se refere a uma OCI (Ofertas de Cuidados Integrados) e, portanto, a mesma deve ser do tipo "Padrão"',
    informeRsePadrao: 'Detectamos que esta é a primeira solicitação do paciente para este procedimento e unidade executora. Esta solicitação foi marcada como sendo do tipo padrão',
    iniciandoSolicitacao: 'Iniciando solicitação',
    instituicaoAutorizadora: 'Instituição autorizadora',
    instituicaoExecutora: 'Instituição executora',
    instrucaoVinculoAutorizadorComplexoRegulatorio: `<span>- Parametrização dos profissionais autorizadores nos complexos regulatórios.</span>
                                <span>- A partir dessa tela, é possível realizar o cadastro dos profissionais autorizadores nos diferentes complexos regulatórios do sistema.</span>
                                <span>- A partir dessa tela, também é possível descadastrar o profissional de um complexo regulatório previamente cadastrado.</span>`,
    invalidado: 'Invalidado',
    invalidandoNumeroRse: 'Invalidando número da RSE',
    invalidar: 'Invalidar',
    invalidarNumeroRse: 'Invalidar número da RSE',
    justificativa: 'Justificativa',
    justificativaProcedimento: 'Justificativa do procedimento',
    justificativaSolicitacao: 'Justificativa da solicitação',
    liberacaoUnacon: 'Conforme DELIBERAÇÃO 092/CIB/2019 - A inserção dos pedidos de PET-CT no módulo ambulatorial, deve ser feita pela Unidade Hospitalar solicitante (UNACON/CACON).',
    medicoAutorizador: 'Médico autorizador',
    mensagemAberturaProcesso: 'Você deseja iniciar uma nova solicitação de RSE? Ao confirmar, um novo rascunho será criado.',
    mensagemDevolucao: 'Para quem você deseja devolver este processo?',
    mensagemOperacao: 'Deseja realizar esta operação?',
    mensagemOperacao: 'Deseja realizar esta operação?',
    mensagemOperacaoAprovacao: 'Deseja aprovar esta solicitação?',
    mensagemOperacaoAutorizacao: 'Deseja autorizar esta solicitação?',
    motivoDevolucaoPadrao: `                Trata-se de reivindicação, ao SUS, de exame tipo tomografia por emissão de pósitrons (PET-CT ou PET Scan), por (preencher o diagnóstico da doença). A matéria é regida pela Portaria 1.340, de 1º. de dezembro de 2014, do Ministério da Saúde. A PET-CT não é um exame para rastreamento, para confeccionar um primeiro diagnóstico, para mera investigação inicial da existência ou não de implantes secundários, nem para fazer diagnóstico diferencial em situações duvidosas. Ela amplia e refina as informações sobre diagnósticos já confirmados através de outros métodos.
                                Não houve aprovação pela Comissão Nacional de Incorporação de Tecnologias pelo SUS (CONITEC) à incorporação da tecnologia em casos deste tipo, com este diagnóstico, por precariedade de evidências científicas favoráveis quanto à sua eficácia, eficiência e efetividade. Há outras investigações pelas quais a PET-CT pode ser intercambiada. O procedimento, portanto, neste caso, não pode ser realizado pelo SUS. É substituível por outros exames disponíveis.
                                Não há protocolo aprovado pelo Ministério da Saúde, concedendo o exame, para a indicação diagnóstica constante no pedido atual, pois ela não está coberta pelas portarias nos. 7 e 9, de 22 de abril de 2014, nem pela portaria no. 8, de 14 de abril de 2014, da Secretaria de Ciência, Tecnologia e Insumos Estratégicos do Ministério da Saúde. O procedimento, para este diagnóstico, não está padronizado na Tabela SIGTAP ou nas listas de procedimentos aprovadas na Comissão Intergestores Tripartite, atuante em Brasília. O pedido não cabe na Portaria 1.340, de 01/12/2014 do Ministério da Saúde. Sua concessão feriria, pois, o Art. 19-M da Lei 8.080/90.
                                A PET-CT, para esta indicação, além de não fazer parte da RENASES, não compõe as listas de procedimentos do SUS. Para incluí-la no rol dos procedimentos, caso venham a ocorrer novos dados científicos, as entidades de pesquisa precisarão montar e aprovar processo, junto à CONITEC, no Ministério da Saúde, em Brasília, segundo os ditames do Decreto no. 7.646, de 21 de dezembro de 2011, da Lei no. 12.401, de 28/04/2011 e da Lei 8.080 de 19 de setembro de 1990. Não cabe, pois, ao Executivo Estadual, ao Judiciário, ou a Prefeituras realizar a incorporação desta tecnologia ao sistema público de saúde, de forma alheia à Comissão Nacional de Incorporação de Tecnologias (CONITEC) e de forma alheia à legislação.`,
    necessitaAnexo: 'Ao menos um anexo é obrigatório',
    necessitaLaudoMedicoExamesComplementares: 'A adição do laudo médico e do exame complementar é obrigatória',
    nenhumaSolicitacaoContinuidade: 'Nenhuma solicitação de continuidade encontrada para este processo',
    nomeAutorizador: 'Nome do autorizador',
    novaSolicitacao: 'Nova solicitação',
    numeroAcaoJudicial: 'Número da ação judicial',
    numeroRse: 'Número da RSE',
    numeroSolicitacaoSisreg: 'Número da solicitação no SISREG',
    numeroAutorizacaoControleAC: 'Número de autorização de controle AC',
    numeroSolicitacao: 'Número da solicitação',
    outros: 'Outros',
    pesquisaRse: 'Pesquisa de processos',
    pesquisaSolicitacoes: 'Pesquisa de solicitações',
    procedenciaPedido: 'Procedência do pedido',
    procedenciaProcesso: 'Procedência do processo',
    processoRse: 'Processo de RSE',
    processoCancelado: 'Processo cancelado',
    processoDesabilitado: 'Não é possível selecionar esse processo',
    processoDevolvido: 'Processo devolvido',
    processoSelecionado: 'processo selecionado.',
    processosSelecionados: 'processos selecionados.',
    quantidade: 'Quantidade',
    rascunho: 'Rascunho',
    rascunhoSalvoSucesso: 'Rascunho salvo com sucesso',
    resumoAnamnese: 'Resumo da anamnese e exame físico',
    resumoExameFisico: 'Resumo do exame físico',
    salvandoRascunho: 'Salvando rascunho',
    selecaoMultipla: 'Seleção múltipla',
    selecionarRestantes: 'Selecionar restante(s)',
    selecionarTodos: 'Selecionar todos',
    semNumero: 'Sem número',
    sequencialSemLetras: 'O número sequencial do processo não deve possuir letras',
    situacaoNumeroRse: 'Situação do número da RSE',
    solicitacaoEnviada: 'Solicitação enviada com sucesso.',
    solicitacaoLaudo: 'Solicitação do laudo',
    solicitacaoNovoRse: 'Solicitação de serviço especial',
    solicitacoesContinuidade: 'Solicitações de continuidade',
    solicitarNumeroRse: 'Solicitar número da RSE',
    sucessoOperacao: 'Operação realizada com sucesso',
    textoAlterarNumeroRse: 'Você está prestes a alterar o número da RSE para este processo. Por favor, escolha o que deseja fazer com o número de RSE atual:',
    textoConfirmarEdicaoSolicitacao: 'Deseja salvar os dados da alteração?',
    textoConfirmarEnvio: 'Deseja encaminhar a solicitação?',
    textoConfirmarRascunhoSolicitacao: 'Deseja salvar o rascunho da solicitação?',
    tipoProcesso: 'Tipo de processo',
    tipoSolicitacao: 'Tipo de solicitação',
    dataExecucao: 'Data de execução',
    dataAltaPaciente: 'Data de alta do paciente',
    aih: 'AIH',
    sisreg: 'SISREG',
    valorNotaFiscal: 'Valor da nota fiscal (R$)',
    dataPreenchimentoComprovacaoServico: 'Data de preenchimento',
    tooltipEncaminhamento24Horas: 'Atenção! Você tem menos de 24 horas para encaminhar este processo',
    tooltipEncaminhamento36Horas: 'Atenção! Você tem menos de 36 horas para encaminhar este processo',
    tooltipEncaminhamento48Horas: 'Você deve encaminhar este processo em até 48 horas',
    tooltipEncaminhamentoAtrasado: 'Atenção! O encaminhamento do processo está atrasado',
    tooltipComprovacaoServicoDevolvida: 'A comprovação de serviço foi devolvida e necessita de atenção.',
    tooltipPreencherComprovacaoServico: 'A comprovação de serviço deve ser preenchida para deferimento pelo operador.',
    tooltipAguardandoDeferimentoOperador: 'Aguardando deferimento do operador para aprovação da comprovação de serviço.',
    tooltipComprovacaoServicoDeferida: 'A comprovação de serviço foi deferida.',
    verificamosRseProcessoPaciente: 'Acesse AQUI o histórico de processos de RSE já aprovadas para esse paciente.',
    vinculoAutorizadorComplexosRegulatorios: 'Vínculo de autorizadores aos complexos regulatórios',
    servicoEspecial: 'Serviço Especial',
    demandaJudicial: 'Demanda judicial',
    prioridade: 'Prioridade',
    comprovacaoServico: 'Comprovação de serviço',
    tipoServicoEspecial: 'Tipo de serviço especial',
    comprovacaoServicoRealizada: 'Comprovação',
    novo: 'Novo',
    comprovacaoServicoDevolvida: 'Comprovação',
    comprovacao: 'Comprovação',
    comprovado: 'Comprovado',
    finalizado: 'Finalizado',
    alterarComprovacaoServico: 'Alterar comprovação de serviço',
    devolverComprovacaoServico: 'Devolver comprovação de serviço',
    deferir: 'Deferir',
    comprovar: 'Comprovar',
    mensagemOperacaoDeferirComprovacaoServico: 'Deseja deferir esta comprovação de serviço?',
    mensagemOperacaoDevolverComprovacaoServico: 'Deseja devolver esta comprovação de serviço?',
    atencaoAdicaoAnexosComprovacaoServico: 'Todos os anexos são obrigatórios.',
    anexosObrigatoriosComprovacaoServico: 'Todos os anexos são obrigatórios.',
    imprimirComprovacaoServico: 'Imprimir comprovação',
    finalizarComprovacaoServico: 'Finalizar comprovação de serviço',
    mensagemNovaSolicitacaoValidade: 'O prazo de validade desta solicitação é de seis meses a partir da data de abertura do processo. Caso expire, um novo processo deve ser solicitado.'
};